/* eslint-disable react/no-did-mount-set-state */
import React from 'react/addons';
import cx from 'classnames';

import i18n from 'ofs/i18n';

function noop() {}

var gettext = i18n.gettext;

var MESSAGES = {
  PRICE_PER_NIGHT: gettext('Price per night'),
  CHOOSE_LOCATION: gettext('Choose a location to enable filtering by price')
};


/**
 * get {clientX, clientY} positions of control
 * Credit: https://github.com/mzabriskie/react-draggable/blob/fcef772698cc7198fc345cea3c5c52deb1544188/lib/draggable.js#L88-L97
 */
function getControlPosition(event) {
  var position = (event.touches && event.touches[0]) || event;
  return {
    clientX: position.clientX,
    clientY: position.clientY
  };
}


var RangeHandle = React.createClass({
  propTypes: {
    value: React.PropTypes.number.isRequired, // percent
    rangeWidth: React.PropTypes.number.isRequired, // size of progress bar
    disabled: React.PropTypes.bool,
    onMove: React.PropTypes.func.isRequired,
    onMoveFinish: React.PropTypes.func.isRequired
  },

  getInitialState() {
    return {
      isDragging: false,
      dragInitialValue: null,
      dragOrigin: null
    };
  },

  onHandleStart(event) {
    if (this.props.disabled) {
      return false;
    }

    var dragPoint = getControlPosition(event);

    this.setState({
      isDragging: true,
      dragInitialValue: this.props.value,
      dragOrigin: dragPoint.clientX
    });

    document.addEventListener('mousemove', this.onHandleMove);
    document.addEventListener('mouseup', this.onHandleEnd);

    // touch events
    document.addEventListener('touchmove', this.onHandleMove);
    document.addEventListener('touchend', this.onHandleEnd);
  },

  onHandleMove(event) {
    var {rangeWidth} = this.props;
    var {dragInitialValue, dragOrigin} = this.state;

    var dragPoint = getControlPosition(event);

    var delta = dragPoint.clientX - dragOrigin;
    var dx = 100 * delta / rangeWidth;
    var nextValue = dragInitialValue + dx;

    this.props.onMove(nextValue);
  },

  onHandleEnd(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      isDragging: false,
      dragInitialValue: null,
      dragOrigin: null
    });

    document.removeEventListener('mousemove', this.onHandleMove);
    document.removeEventListener('mouseup', this.onHandleEnd);

    // touch events
    document.removeEventListener('touchmove', this.onHandleMove);
    document.removeEventListener('touchend', this.onHandleEnd);

    this.props.onMoveFinish(event);
  },

  render() {
    var {value} = this.props;
    var {isDragging} = this.state;

    var handleStyles = {
      left: value + '%'
    };

    var handleClasses = {
      'ofs-RangeSlider__Handle': true,
      'ofs-RangeSlider__Handle--is-selected': isDragging
    };

    return (
      <div className="ofs-RangeSlider__HandleWrapper"
        style={handleStyles}
        onClick={this.stopPropagation}
        onMouseDown={this.onHandleStart}
        onTouchStart={this.onHandleStart}>
        <div className={cx(handleClasses)} />
      </div>
    );
  }
});


var PriceSlider = React.createClass({
  propTypes: {
    limits: React.PropTypes.array.isRequired, // array of 2 values
    values: React.PropTypes.array.isRequired,
    inputNames: React.PropTypes.array.isRequired,
    currencyCode: React.PropTypes.string.isRequired,
    disabled: React.PropTypes.bool,
    step: React.PropTypes.number, // amount to step each change by
    onChange: React.PropTypes.func
  },

  getDefaultProps() {
    return {
      step: 1,
      onChange: noop
    };
  },

  getInitialState() {
    return {
      dragging: false,
      selectedValues: [],
      rangeWidth: 0
    };
  },

  getMinValue() {
    const {values} = this.props;
    const {dragging, selectedValues} = this.state;

    if (dragging) {
      return selectedValues[0] || values[0];
    }
    return values[0];
  },

  getMaxValue() {
    const {values} = this.props;
    const {dragging, selectedValues} = this.state;

    if (dragging) {
      return selectedValues[1] || values[1];
    }
    return values[1];
  },

  // nextValue is a normalized value
  handleMinValueChange(nextValue) {
    var {limits, values, step} = this.props;

    // un normalize value
    var actualValue = Math.round(((nextValue / 100) * limits[1]) + limits[0]);

    var nextActualValue = Math.round(actualValue / step) * step;

    var selectedValues = this.state.selectedValues.slice(0);

    var maxValue = selectedValues[1] || values[1];
    if (actualValue < maxValue) {
      selectedValues[0] = nextActualValue;
      this.setState({dragging: true, selectedValues});
    }
  },

  handleMaxValueChange(nextValue) {
    var {limits, values, step} = this.props;
    var {selectedValues} = this.state;

    // un normalize value
    var actualValue = Math.round((nextValue / 100) * limits[1]);

    var nextActualValue = Math.round(actualValue / step) * step;

    // copy selectedValues
    selectedValues = selectedValues.slice(0);

    var minValue = selectedValues[0] || values[0];

    if (actualValue > minValue) {
      selectedValues[1] = nextActualValue;
      this.setState({dragging: true, selectedValues});
    }
  },

  handleChange() {
    var {values, inputNames, limits} = this.props;
    var {selectedValues} = this.state;

    var minValue = Math.max((selectedValues[0] || values[0]), limits[0]);
    var maxValue = Math.min((selectedValues[1] || values[1]), limits[1]);

    var newValues = {};
    newValues[inputNames[0]] = minValue;
    newValues[inputNames[1]] = maxValue;

    this.setState({
      dragging: true
    });

    this.props.onChange(newValues);
  },

  componentDidMount() {
    var el = this.refs['range-line'].getDOMNode();
    var rect = el.getBoundingClientRect();

    this.setState({
      'rangeWidth': rect.width
    });
  },

  render() {
    var {limits, inputNames, currencyCode, disabled} = this.props;
    var {rangeWidth} = this.state;

    var minValue = Math.max(this.getMinValue(), limits[0]);
    var maxValue = Math.min(this.getMaxValue(), limits[1]);

    var normalizedMin = ((minValue - limits[0]) / limits[1]) * 100;
    var normalizedMax = (maxValue / limits[1]) * 100;

    return (
      <div className="ofs-Form__Field">
        {disabled ?
          <p className="ofs-Form__HelpText ofs-Form__HelpText--above">{MESSAGES['CHOOSE_LOCATION']}</p>
          : null}
        <div className="ofs-PriceSlider">
          {disabled ? <div className="ofs-PriceSlider__DisableCover"></div> : null}

          <label className="ofs-Form__Label">
            {MESSAGES['PRICE_PER_NIGHT']}
            <div className="ofs-Form__Label--right">
              {currencyCode}{minValue} – {currencyCode}{maxValue}{maxValue === limits[1] ? "+" : null}
            </div>
          </label>

          <div className="ofs-RangeSlider" onClick={this.onProgressBarClick}>
            <div className="ofs-RangeSlider__RangeLine" ref="range-line">
              <div className="ofs-RangeSlider__RangeFill" style={{
                left: normalizedMin + '%',
                right: 100 - normalizedMax + '%'
              }}/>
            </div>

            <RangeHandle value={normalizedMin} rangeWidth={rangeWidth}
              disabled={disabled} onMove={this.handleMinValueChange}
              onMoveFinish={this.handleChange} />
            <RangeHandle value={normalizedMax} rangeWidth={rangeWidth}
              disabled={disabled} onMove={this.handleMaxValueChange}
              onMoveFinish={this.handleChange} />
          </div>
          <div className="ofs-RangeSlider__Labels">
            <div className="u-pull-left">{currencyCode}{limits[0]}</div>
            <div className="u-pull-right">{currencyCode}{limits[1]}+</div>
          </div>

          <input type="hidden" name={inputNames[0]} value={minValue} />
          <input type="hidden" name={inputNames[1]} value={maxValue} />
        </div>
      </div>
    );
  }
});

export default PriceSlider;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/search/views/PriceSlider.jsx
 **/